export const DRINKS_INCLUDED_CLUB_IDS = [
  '7ce757d7-919c-11e9-846c-06b12363b88e',
  '7ce981e1-919c-11e9-846c-06b12363b88e',
  '2d54a10a-d1ef-4c30-ae9b-12ddbff4ba61',
  '3b937ee6-4136-4788-9a4a-2b3aeab652ce',
  '8cfbcd22-6193-44df-bbdb-5798143c94d6',
  '02e72946-8e2d-45f0-92ab-742170daf446',
  '7ce71c7e-919c-11e9-846c-06b12363b88e',
  '172e8962-c64d-4da8-ac14-1c43f1bd9896',
  '3bd6dca4-4781-40dc-b3bb-02aaf3691b3c',
  '9f5e00ef-fcc8-4ac5-ab93-ff3a8aee758c',
  '1abb4cdc-dd17-499e-b73f-a0a923c659fe',
];
